import { createFileRoute } from '@tanstack/react-router';
import { DocumentForm } from '@/pages/documents/form';
import { PROTECTED, PAYMENTS } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${PAYMENTS}`;

export const Route = createFileRoute(
  '/protected/_layout/payments/_layout/documents/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: PaymentDocumentModal,
});

function PaymentDocumentModal() {
  const { id } = Route.useParams();
  return <DocumentForm id={id} returnUrl={RETURN_URL} />;
}
